import { ReactiveVar } from '@apollo/client';
import { useSyncExternalStoreWithSelector } from 'use-sync-external-store/with-selector';

export function useReactiveVarWithSelector<T, Selection>(
  rv: ReactiveVar<T>,
  selector: (state: T) => Selection,
  isEqual?: (a: Selection, b: Selection) => boolean
): Selection {
  const value = useSyncExternalStoreWithSelector(
    (onStoreChange: () => void) => {
      let unsubscribe: () => void;
      const listener = () => {
        onStoreChange();
        unsubscribe = rv.onNextChange(listener);
      };

      unsubscribe = rv.onNextChange(listener);
      return () => unsubscribe();
    },
    rv,
    rv,
    selector,
    isEqual
  );

  return value;
}
